import React from "react";


// (opcional) mapeia as cores do tremor p/ classes do Tailwind (usado no pontinho da legenda)
const colorClass = {
  slate: "bg-slate-500",
  gray: "bg-gray-500",
  zinc: "bg-zinc-500",
  neutral: "bg-neutral-500",
  stone: "bg-stone-500",
  red: "bg-red-500",
  orange: "bg-orange-500",
  amber: "bg-amber-500",
  yellow: "bg-yellow-500",
  lime: "bg-lime-500",
  green: "bg-green-500",
  emerald: "bg-emerald-500",
  teal: "bg-teal-500",
  cyan: "bg-cyan-500",
  sky: "bg-sky-500",
  blue: "bg-blue-500",
  indigo: "bg-indigo-500",
  violet: "bg-violet-500",
  purple: "bg-purple-500",
  fuchsia: "bg-fuchsia-500",
  pink: "bg-pink-500",
  rose: "bg-rose-500",
};

const valueFormatter = (n) => Intl.NumberFormat("pt-BR").format(n);

export function CustomTooltip({ active, payload, label }) {
  if (!active || !payload || payload.length === 0) return null;

  // pega o objeto original da linha do dataset
  const row = payload[0]?.payload ?? {};
  // soma todas as chaves numéricas (que correspondem às categorias do gráfico)
  const total = Object.entries(row)
    .filter(([k, v]) => typeof v === "number")
    .reduce((acc, [, v]) => acc + v, 0);

  return (
    <div className="rounded-md border border-gray-200 bg-white text-sm shadow-md dark:border-gray-800 dark:bg-gray-950">
      <div className="border-b border-inherit px-4 py-2">
        <p className="font-medium text-gray-900 dark:text-gray-50">{label}</p>
      </div>

      <div className="space-y-1 px-4 py-2">
        {payload.map((p, i) => {
          const value = Number(p.value) || 0;
          const percent = p.payload.percentage > 0 ? p.payload.percentage : 0;
          const dotClass = colorClass[p.color] || "bg-gray-400";
          const category = p.category || p.name;

          return (
            <div key={i} className="flex items-center justify-between space-x-8">
              <div className="flex items-center space-x-2">
                <span aria-hidden className={`size-2 shrink-0 rounded-xs ${dotClass}`} />
                <p className="whitespace-nowrap text-gray-700 dark:text-gray-300">
                  {category}
                </p>
              </div>

              <div className="flex items-baseline space-x-2 tabular-nums">
                <p className="text-right font-medium text-gray-900 dark:text-gray-50">
                  {valueFormatter(value)}
                </p>
                {percent > 0 &&
                  <span className="text-gray-500 dark:text-gray-400">
                    ({percent.toFixed(1)}%)
                  </span>
                }
              </div>
            </div>
          );
        })}
      </div>

      {/* <div className="border-t border-inherit px-4 py-2 text-right text-xs text-gray-500 dark:text-gray-400">
        Total: {valueFormatter(total)}
      </div> */}
    </div>
  );
}